import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UsersService {
    
    constructor(private httpClient: HttpClient) { }

    private handleError(error: any) {
        return throwError(error);
    }

    // Get User List
    getUsers(pageIndex: any, limit: any, searchFilter: any, from_date: any, to_date: any): Observable<any> {
        const filter = searchFilter ? '&search=' + searchFilter : '';
        const fromDateParam = from_date !== undefined ? from_date : '';
        const toDateParam = to_date !== undefined ? to_date : '';

        return this.httpClient
            .get(environment.baseURL + `/users?page=${pageIndex}&limit=${limit}${filter}&from_date=${fromDateParam}&to_date=${toDateParam}`)
            .pipe(catchError(this.handleError));
    }

    // User Activity List
    getUserActivity(pageIndex: any, limit: any, id: any, searchFilter: any): Observable<any> {
        const filter = searchFilter ? '&search=' + searchFilter : ''
        return this.httpClient
            .get(environment.baseURL + `/userActivity?page=${pageIndex}&limit=${limit}&user_id=${id}${filter}`)
            .pipe(catchError(this.handleError));
    }

    // Fetch User
    fetchUserList(): Observable<any> {
        return this.httpClient
            .get(environment.baseURL + `/users/fetchUserList`)
            .pipe(catchError(this.handleError));
    }

    // Get User
    getCurrentUser(): Observable<any> {
        return this.httpClient
            .get(environment.baseURL + `/auth/me`)
            .pipe(catchError(this.handleError));
    }

    // User View By ID
    getUserViewById(userId: number): Observable<any> {
        return this.httpClient
            .get(environment.baseURL + `/users/${userId}`)
            .pipe(catchError(this.handleError));
    }

    // Change Password
    ChangePassword(data: any): Observable<any> {
        return this.httpClient
            .put(environment.baseURL + `/auth/change/password`, data)
            .pipe(catchError(this.handleError));
    }
}
